<template>
  <div class="equipment">
    <div>
      <template v-for="equipment in cameraEquipments" :key="equipment.path">
        <PeripheralEquipmentIcon
          :equipment=equipment
        />
      </template>
    </div>

    <div>
      <template v-for="equipment in tdsensorEquipments" :key="equipment.path">
        <PeripheralEquipmentIcon
          :equipment=equipment
        />
      </template>
    </div>

    <div>
      <template v-for="equipment in etcEquipments" :key="equipment.path">
        <PeripheralEquipmentIcon
          :equipment=equipment
        />
      </template>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue';
import PeripheralEquipmentIcon from '@/components/VehicleParts/PeripheralEquipmentIcon'
import {
  PERIPHERAL_EQUIPMENT_LIST,
  ICON_NONE,
  TYPE_CAMERA,
  TYPE_TDSENSOR,
  TYPE_ETC,
  CONNECT_STATUS_ON
} from '@/services/consts/vehicle'

type VehicleParameterType = {
  [key: string]: string | VehicleParameterType
}
type EquipmentType = {
  icon: string,
  type: string,
  name: string,
  path: string,
}

const props = defineProps<{
  parameters: VehicleParameterType
}>()

const cameraEquipments = ref<EquipmentType[]>([])
const tdsensorEquipments = ref<EquipmentType[]>([])
const etcEquipments = ref<EquipmentType[]>([])

onMounted(() => {
  PERIPHERAL_EQUIPMENT_LIST.forEach((equipment) => {
    const copyedEquipment = JSON.parse(JSON.stringify(equipment));
    const path = equipment.path as string
    const connectStatus = getConnectStatusByPath(props.parameters, path)

    if (connectStatus != CONNECT_STATUS_ON) {
      copyedEquipment.icon = ICON_NONE
    }

    let tdsensorRootStatus
    switch (equipment.type) {
      case TYPE_CAMERA:
        cameraEquipments.value.push(copyedEquipment)
        break;

      case TYPE_TDSENSOR:
        tdsensorRootStatus = getConnectStatusByPath(props.parameters, 'tdsensor.tdrfsensor')
        if (tdsensorRootStatus != CONNECT_STATUS_ON) {
          copyedEquipment.icon = ICON_NONE
        }
        tdsensorEquipments.value.push(copyedEquipment)
        break;

      case TYPE_ETC:
        etcEquipments.value.push(copyedEquipment)
        break;
    }
  })
})

function getConnectStatusByPath(parameters: VehicleParameterType, path: string): string {
  let device = {} as VehicleParameterType
  const keys = path.split('.');
  if (parameters[keys[0]]) {
    device = parameters[keys[0]] as VehicleParameterType
  }

  if(device && device[keys[1]]) {
    return device[keys[1]] as string
  }

  return ''
}

</script>

<style>
.equipment {
  white-space: nowrap
}
.equipment span {
  font-size: 18px;
}
</style>
